<template>
  <div class="quiz-container">
    <div v-if="!isLoading">
      <template v-if="setSoal">
        <!-- Question Options Card -->
        <div class="options-card mb-4">
          <div class="options-grid">
            <div
              v-for="(option, index) in [
                'pila',
                'pilb',
                'pilc',
                'pild',
                'pile',
              ]"
              :key="index"
              class="option-item"
              v-html="setSoal[option]"
            ></div>
          </div>
        </div>

        <!-- Main Question Card -->
        <div class="question-card mb-4">
          <div class="question-text" v-html="setSoal.soal"></div>
        </div>

        <!-- Answer Buttons -->
        <div class="answer-buttons">
          <button
            v-for="option in ['A', 'B', 'C', 'D', 'E']"
            :key="option"
            :id="'jawab-' + option.toLowerCase() + '-' + setSoal.id"
            @click="
              nextSubmit(
                option + '/' + setSoal.id + '/' + idUser + '/' + setIdSoal
              )
            "
            class="answer-btn"
          >
            {{ option }}
          </button>
        </div>
      </template>
    </div>

    <div v-else class="loader-container">
      <loading-vue></loading-vue>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import loadingVue from "@/components/loading.vue";

export default {
  name: "QuizComponent",
  components: { loadingVue },
  props: {
    dataSoal: {
      type: Object,
      required: true,
    },
    idNextSoal: {
      type: [Number, String],
      required: true,
    },
    userId: {
      type: Number,
      required: true,
    },
  },

  data() {
    return {
      isLoading: false,
      setSoal: this.dataSoal,
      setIdSoal: this.idNextSoal,
      idUser: this.userId,
      dataJawab: [],
    };
  },

  watch: {
    dataSoal: {
      handler(val) {
        this.setSoal = val;
      },
      deep: true,
    },
    idNextSoal(val) {
      this.setIdSoal = val;
    },
    userId(val) {
      this.idUser = val;
    },
  },

  mounted() {
    localStorage.removeItem("jawaban");
    this.startAutoSave();
  },

  methods: {
    startAutoSave() {
      setInterval(async () => {
        if (this.dataJawab.length > 0) {
          await this.simpanJawaban();
        }
      }, 3000);
    },

    async simpanJawaban() {
      const answers = [...this.dataJawab];
      this.dataJawab = [];
      localStorage.setItem("jawaban", JSON.stringify(answers));
      await this.saveJawab(answers);
    },

    async saveJawab(value) {
      try {
        await axios.post(
          `${process.env.VUE_APP_API_BASE_URL}/api/json/ujian/jawab-kecermatan`,
          { get_jawab: value }
        );
        return "Success";
      } catch (error) {
        console.error("Error saving answers:", error);
      }
    },

    nextSubmit(value) {
      this.dataJawab.push(value);
      this.$emit("nextQuestion", true);
    },
  },
};
</script>

<style scoped>
.quiz-container {
  margin: 0 auto;
}

.options-card {
  background: white;
  border-radius: 16px;
  padding: 2rem;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1),
    0 2px 4px -1px rgba(0, 0, 0, 0.06);
}

.options-grid {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 2rem;
  justify-items: center;
  align-items: center;
}

.option-item {
  font-size: 3.5rem;
  font-weight: 700;
  color: #2d3748;
}

.question-card {
  background: white;
  border-radius: 16px;
  padding: 2.5rem;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1),
    0 2px 4px -1px rgba(0, 0, 0, 0.06);
}

.question-text {
  font-size: 4rem;
  font-weight: 700;
  text-align: center;
  letter-spacing: 3rem;
  color: #2d3748;
}

.answer-buttons {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 1rem;
  margin-top: 2rem;
}

.answer-btn {
  background: white;
  border: 2px solid #805ad5;
  border-radius: 12px;
  padding: 1rem 2rem;
  font-size: 1.25rem;
  font-weight: 600;
  color: #805ad5;
  transition: all 0.2s ease;
  position: relative;
  overflow: hidden;
}

.answer-btn::after {
  content: "";
  position: absolute;
  top: 50%;
  left: 50%;
  width: 0;
  height: 0;
  background: rgba(128, 90, 213, 0.1);
  border-radius: 50%;
  transform: translate(-50%, -50%);
  transition: width 0.3s ease, height 0.3s ease;
}

.answer-btn:hover {
  background: #805ad5;
  color: white;
  transform: translateY(-2px);
}

.answer-btn:active::after {
  width: 300px;
  height: 300px;
}

.loader-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 200px;
}

@media (max-width: 768px) {
  .options-grid {
    gap: 1rem;
  }

  .option-item {
    font-size: 2.5rem;
  }

  .question-text {
    font-size: 3rem;
    letter-spacing: 2rem;
  }

  .answer-buttons {
    grid-template-columns: repeat(5, 1fr);
  }
}

@media (max-width: 480px) {
  .options-grid {
    grid-template-columns: repeat(5, 1fr);
    gap: 0.5rem;
  }

  .option-item {
    font-size: 2rem;
  }

  .question-text {
    font-size: 2rem;
    letter-spacing: 1rem;
  }

  .answer-buttons {
    display: flex;
    flex-wrap: nowrap;
    justify-content: spacebetween;
    gap: 5px;
    width: 100%;
    margin: auto;
  }

  .answer-buttons button {
    flex: 1;
    min-width: auto;
    padding: 10px 5px;
    font-size: 1rem;
    border-radius: 10px;
    text-align: center;
  }

  .answer-buttons button:nth-child(1),
  .answer-buttons button:nth-child(2),
  .answer-buttons button:nth-child(3) {
    width: calc(33.33% - 10px);
  }

  .answer-buttons button:nth-child(4),
  .answer-buttons button:nth-child(5) {
    width: calc(50% - 5px);
  }
}
</style>
